import React, { useState } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { sendTrackingInfo } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import { useTranslation } from 'react-i18next';
import Tour from 'reactour';
import useHideBotMarker from '@panel/commons/hooks/useHideBotmarker';
import { getColor } from '@panel/commons/core/themev3';
import Step from './Step';

const TourContainer = ({ setShowTour, showTour }) => {
  const { t } = useTranslation();
  const [currentStepId, setCurrentStepId] = useState(1);
  useHideBotMarker(showTour);
  const boxStyle = {
    minHeight: '184px',
    width: '350px',
    padding: '16px'
  };

  const tourConfig = [
    {
      style: boxStyle,
      selector: '[data-tour-panel="quality"]',
      content: (
        <Step
          id={1}
          onClose={() => {
            setShowTour(false);
          }}
          title={t('panel.avisos.tour.step1.title')}
          bodyText={t('panel.avisos.tour.step1.body')}
        />
      ),
      position: 'bottom'
    },
    {
      style: boxStyle,
      selector: '[data-tour-panel="leads-info-0"]',
      highlightedSelectors: ['[data-tour-panel="leads-info-1"]'],
      content: (
        <Step
          id={2}
          onClose={() => setShowTour(false)}
          title={t('panel.avisos.tour.step2.title')}
          bodyText={t('panel.avisos.tour.step2.body')}
        />
      ),
      position: 'bottom'
    },
    {
      style: boxStyle,
      selector: '[data-tour-panel="quick-actions-1"]',
      highlightedSelectors: [
        '[data-tour-panel="quick-actions-0"]',
        '[data-tour-panel="quick-actions-2"]',
        '[data-tour-panel="quick-actions-3"]'
      ],
      content: (
        <Step
          id={3}
          onClose={() => setShowTour(false)}
          title={t('panel.avisos.tour.step3.title')}
          bodyText={t('panel.avisos.tour.step3.body')}
        />
      ),
      position: 'bottom'
    }
  ];
  const disableBody = target => disableBodyScroll(target);
  const enableBody = target => enableBodyScroll(target);

  return (
    <>
      <OverrideCss />
      <Tour
        data-panel='panel-tour-container'
        onAfterOpen={disableBody}
        onRequestClose={() => setShowTour(false)}
        onBeforeClose={e => {
          enableBody(e);
          if (currentStepId !== tourConfig.length) {
            sendTrackingInfo('Panel', 'Mis avisos', `Tour virtual-${currentStepId}_Salir`);
          }
          setCurrentStepId(1);
          window.scroll({
            top: 0,
            behavior: 'smooth'
          });
        }}
        showCloseButton={false}
        steps={tourConfig}
        isOpen={showTour}
        rounded={8}
        startAt={0}
        getCurrentStep={curr => setCurrentStepId(curr + 1)}
        disableDotsNavigation
        disableInteraction
        showNumber={false}
        nextButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-next'
            isNext
            as='div'
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Tour virtual-${currentStepId}_Siguiente`);
            }}
          >
            {t('panel.avisos.tour.next')}
          </NavButton>
        )}
        prevButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-back'
            as='div'
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Tour virtual-${currentStepId}_Anterior`);
            }}
          >
            {t('panel.avisos.tour.prev')}
          </NavButton>
        )}
        lastStepNextButton={React.createElement(
          'div',
          {},
          <NavButton
            data-panel='panel-tour-nvaButton-finish'
            isNext
            as='div'
            onClick={() => {
              sendTrackingInfo('Panel', 'Mis avisos', `Tour virtual-${currentStepId}_Finalizar`);
            }}
          >
            {t('panel.avisos.tour.finish')}
          </NavButton>
        )}
        maskClassName='custom-tour-mask'
      />
    </>
  );
};

const OverrideCss = createGlobalStyle`
[data-tour-elem="controls"]{
  justify-content:space-between;
}
[data-tour-elem="left-arrow"]{
  :disabled{
    opacity:0;
  }
}
button.reactour__dot{
  color: #CBD6DC!important;
  background: #CBD6DC!important;
}
button.reactour__dot--is-active{
  color: #7C98A7!important;
  background: #7C98A7!important;
}
.reactour__helper{
  max-width: 350px;
}
.custom-tour-mask{
  opacity:0.7;
}
`;

const NavButton = styled.button`
  width: 80px;
  height: 40px;
  background-color: ${select('white')};
  border-radius: 8px;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  :disabled {
    opacity: 0;
  }
  ${({ isNext }) =>
    isNext &&
    css`
      background-color: ${getColor('primary')};
      color: white;
    `}
`;

export default TourContainer;
